import { Injectable } from '@angular/core';
import { ActiveOrderDsService, OutputUnitDsService } from '@app/core/data-services';
import { PrintLabelEntry, LabelType, LabelPrintInfo } from 'chronos-core-client';
import { Observable } from 'rxjs';
import { LoadingNotificationService, LogService } from 'chronos-shared';
import { notificationTopic } from '@app/shared/utils';
import { finalize, tap, share, switchMap } from 'rxjs/operators';
import { PrintLabelDsService } from '@app/core/data-services/print-label-ds/print-label-ds.service';

@Injectable()
export class PrintLabelService {
  private readonly OUTER_PRINT_LOADING_TOPIC = notificationTopic.outerPrintLabelAction;
  private readonly OUTER_PREPRINT_LOADING_TOPIC = notificationTopic.outerPreprintLabelAction;

  constructor(
    private activeOrderDsService: ActiveOrderDsService,
    private outputUnitDsService: OutputUnitDsService,
    private printLabelDsService: PrintLabelDsService
  ) {}

  public getLabelPrintInfo(productionOrderId: number, labelType: LabelType): Observable<LabelPrintInfo> {
    return this.printLabelDsService.getLabelPrintInfo(productionOrderId, labelType);
  }

  public async printBobbinCoreLabel(producedMaterialId: number, printLabel: PrintLabelEntry): Promise<void> {
    const loadingTopic = printLabel.reprint ? this.OUTER_PRINT_LOADING_TOPIC : this.OUTER_PREPRINT_LOADING_TOPIC;
    LoadingNotificationService.publish(loadingTopic, true);

    return this.printLabelDsService.printBobbinLabel(producedMaterialId, printLabel)
      .pipe(
        tap(() => {
          LogService.success('SUCCESS_MESSAGE.PRINTED_LABELS');
        }),
        finalize(() => {
          LoadingNotificationService.publish(loadingTopic, false);
        })
      ).toPromise();
  }

  public async printLabel(productionOrderId: number, printLabel: PrintLabelEntry): Promise<LabelPrintInfo> {
    const loadingTopic = printLabel.reprint ? this.OUTER_PRINT_LOADING_TOPIC : this.OUTER_PREPRINT_LOADING_TOPIC;

    LoadingNotificationService.publish(loadingTopic, true);
    return this.printLabelDsService.printLabel(productionOrderId, printLabel)
      .pipe(
        switchMap(() => this.printLabelDsService.getLabelPrintInfo(productionOrderId, printLabel.labelType)),
        tap(() => {
          LogService.success('SUCCESS_MESSAGE.PRINTED_LABELS');
        }),
        finalize(() => {
          LoadingNotificationService.publish(loadingTopic, false);
        }),
        share()
      ).toPromise();
  }

  public saveQuantityPerOuter(quantity: number, labelType: LabelType): Observable<void> {
    const productionOrderId: number = this.activeOrderDsService.getActiveOrderId();
    return this.outputUnitDsService.saveQuantityPerOuterAndCopies(
      productionOrderId,
      labelType,
      quantity,
      1);
  }
}
